<template>
  <div class="ecircular-description-view">
    <div
      v-if="ecircular.type!==ecircularType.VENDOR"
      class="hkland-logo"
    >
      <img
        v-region-img-src="'call-center.png'"
        style="zoom: 50%;"
      >
    </div>
    <div
      class="content__description"
      v-html="ecircular.description"
    />
    <div :style="{marginTop: 20 + 'px'}">
      <img
        v-region-img-src="'email-logo-hkland.png'"
        alt="Hongkong Land"
        class="hkland-logo__full"
      >
    </div>
    <div
      :key="new Date().getTime()"
      v-html="ecircular.signature"
    />
  </div>
</template>

<script>
import { E_CIRCULAR_TYPES } from '../consts'

export default {
  name: 'ECircularDescriptionView',
  props: {
    ecircular: {
      type: Object,
      default: () => {},
    },
  },
  data () {
    return {
      ecircularType: E_CIRCULAR_TYPES,
    }
  },
}
</script>

<style lang="scss" scoped>
.ecircular-description-view {
  label {
    margin-top: 0;
    margin-bottom: 0;
  }
  .content__description {
    overflow: auto;
    p {
      margin-bottom: 0 !important;
    }
  }
  background-color: #f2f6f8;
  padding: 35px 30px 30px 30px;
  .hkland-logo {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 20px;

    &__full {
      width: 200px;
    }
  }
}
</style>
